import { cx } from 'class-variance-authority';

export function Divider({ label }: { label: string }) {
  return (
    <div
      className={cx(
        'grid grid-cols-[1fr_auto_1fr] items-center gap-2',
        'w-full text-neutral-dark',
      )}
    >
      <hr />
      {label}
      <hr />
    </div>
  );
}
